import React, { Component, Fragment } from 'react';
import { LinearProgress, Typography } from '@material-ui/core';
import moment from 'moment';
import filesize from 'filesize';
import { withStyles } from '@material-ui/core/styles';
import { Duration, Player } from '../layout';

const viewerStyle = theme => ({
  container: {
    maxWidth: 600
  },
  content: {
    padding: 5
  },
  title: {
    fontSize: '1.6em'
  },
  caption: {
    display: 'inline-block',
    fontSize: '1em',
    marginRight: 5
  },
  field: {
    fontSize: '1em',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.7em'
    }
  },
  thumb: {
    maxWidth: 600,
    height: 400
  }
});

const Viewer = class extends Component {
  componentDidMount = () => {
    this.props.getVideo(this.props.match.params.id);
  };

  render = () => {
    const { classes, data, fetching } = this.props;

    return (
      <Fragment>
        {fetching && <LinearProgress />}
        {data &&
          !fetching && (
            <div align="center">
              <div className={classes.container} align="left">
                {data.url && (
                  <Player
                    videoUrl={`https://content.dev.alulavideo.net/${data.url}`}
                    thumb={`https://content.dev.alulavideo.net/${data.thumb}`}
                  />
                )}
                <div className={classes.content}>
                  <Typography variant="body1" className={classes.field}>
                    <Typography variant="caption" className={classes.caption}>
                      Device:
                    </Typography>
                    {data.device.serialNumber}
                  </Typography>
                  <Typography variant="body1" className={classes.field}>
                    <Typography variant="caption" className={classes.caption}>
                      Start:
                    </Typography>
                    {data.startTime && moment(data.startTime).format('L LT')}
                  </Typography>
                  <Typography variant="body1" className={classes.field}>
                    <Typography variant="caption" className={classes.caption}>
                      End:
                    </Typography>
                    {data.endTime && moment(data.endTime).format('L LT')}
                  </Typography>
                  <div style={{ display: 'flex' }}>
                    <div style={{ flex: 1 }}>
                      <Typography className={classes.field}>
                        <Duration length={data.length} />
                      </Typography>
                    </div>
                    <div style={{ flex: 1 }}>
                      <Typography className={classes.field} align="right">
                        {data.size && filesize(data.size)}
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
      </Fragment>
    );
  };
};

export default withStyles(viewerStyle)(Viewer);



// WEBPACK FOOTER //
// ./src/components/pages/Viewer.js